module.exports = __webpack_public_path__ + "img/cc.01929c0f.jpg";